import {DateTime, PhoneCheckReplies, PhoneNumber} from "@/modules/models";
import Api from "@/components/prelogin/Api";
import rd from "@/modules/vRoutedefs";

export interface PhoneCheckReply {
    pendingCreated?: string;
    confirmedCreated?: string;
    errorMsg?: string;
    phoneInvalidMsg?: string;
}


export const phoneCheck = async (phone: PhoneNumber | null, api: Api): Promise<PhoneCheckReply> => {
    if(phone != null) {
        const resp = await api.checkPhoneRegistration(phone);
        if (resp instanceof PhoneCheckReplies) {
            const checkReplies = resp.replies;
            const pendingCodeCreatedMillisString = checkReplies
                .filter((r) => r.replyNum === PhoneCheckReplies.PENDING_CODE && r.created != null)
                .map((r) => (r.created as DateTime).millis().toString())
                .shift() || null;
            const confirmedCodeCreatedMillisString = checkReplies
                .filter((r) => r.replyNum === PhoneCheckReplies.CONFIRMED_CODE && r.created != null)
                .map((r) => (r.created as DateTime).millis().toString())
                .shift() || null;

            return {
                pendingCreated: pendingCodeCreatedMillisString || "",
                confirmedCreated: confirmedCodeCreatedMillisString || "",
            };
        } else { // something wrong, ApiMessage returned
            return {
                errorMsg: resp.msg,
            }
        }
    } else {
        return {
            phoneInvalidMsg: "Mobilnummer må fylles ut",
        };
    }
};

export const phoneCheckedLocation = (phone: PhoneNumber, pendingCreated?: string, confirmedCreated?: string, redir?: string) => ({
    name: rd.login.checked.name,
    params: {
        countrycode: phone.countrycode.toString(),
        number: phone.number.toString(),
    },
    query: {
        pendingCreated: pendingCreated || "",
        confirmedCreated: confirmedCreated || "",
        redir: redir || "",
    }
});

export const signupLocation = (phone: PhoneNumber, redir: string | null) => ({
    name: rd.login.signup.name,
    params: {
        countrycode: phone.countrycode.toString(),
        number: phone.number.toString()
    },
    query: {
        redir: redir || ""
    }
});